var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTesst1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 66,
    viewBox: "0 0 42 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.5833 12.5833H6.41667C5.64312 12.5833 4.90125 12.8906 4.35427 13.4376C3.80729 13.9846 3.5 14.7264 3.5 15.5V59.25C3.5 60.0235 3.80729 60.7654 4.35427 61.3124C4.90125 61.8594 5.64312 62.1667 6.41667 62.1667H35.5833C36.3569 62.1667 37.0988 61.8594 37.6457 61.3124C38.1927 60.7654 38.5 60.0235 38.5 59.25V15.5C38.5 14.7264 38.1927 13.9846 37.6457 13.4376C37.0988 12.8906 36.3569 12.5833 35.5833 12.5833Z",
    stroke: "#5B4B86",
    strokeWidth: 5.83333,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 24.25H38.5",
    stroke: "#5B4B86",
    strokeWidth: 5.83333,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 19.875V28.625M38.5 19.875V28.625",
    stroke: "#5B4B86",
    strokeWidth: 5.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6667 3.83333H9.33337V12.5833H32.6667V3.83333Z",
    stroke: "#5B4B86",
    strokeWidth: 5.83333,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1666 43.2083H26.8333M21 37.375V49.0417",
    stroke: "#5B4B86",
    strokeWidth: 5.83333,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTesst1);
export default __webpack_public_path__ + "static/media/tesst1.d1bb461a74552bb3f0f3a92164dfe165.svg";
export { ForwardRef as ReactComponent };